import { SwapView1526g6cz7z56r as SwapView } from '../direct/SwapView.commonHtml.mjs';
import { ensureOutermostElement1f4fzdv7yw0ql as ensureOutermostElement } from '../NativeElement.mjs';
import { Debugger_getInstancengm4b9abzu1y as Debugger_getInstance } from '../Element.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_theme90wn9glxu60a as get_theme } from '../Element.ext.mjs';
import { firstOrNull1982767dljvdy as firstOrNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { report1vfr9zf0i9d9p as report } from '../../debugger.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { awaitOnce3bs0u39jtmrli as awaitOnce } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { split3oko73n02120n as split } from '../ElementWriter.ext.mjs';
import { set_pageNavigator2tlfgk6pqrj4q as set_pageNavigator } from '../../navigation/Navigator.mjs';
import {
  MainContentSemantic_getInstance31xiavoja82c3 as MainContentSemantic_getInstance,
  ForcePaddingSemantic_getInstance2xrz1oepj1itn as ForcePaddingSemantic_getInstance,
} from '../../models/Theme.mjs';
import { themed2vu67ornd4jps as themed } from '../themeDerivations.mjs';
import { get_asMain94c2jepff2gk as get_asMain } from '../direct/modifiers.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function navigatorView(_this__u8e3s4, navigator) {
  // Inline function 'com.lightningkite.kiteui.views.direct.swapView' call
  // Inline function 'com.lightningkite.kiteui.views.write' call
  var element = new (SwapView())(_this__u8e3s4.get_context_h02k06_k$());
  ensureOutermostElement(element);
  _this__u8e3s4.willAddChild_hz2iwc_k$(element);
  var $this$swapView = element;
  $this$swapView.set_debugName_wihv62_k$('navigatorView');
  Debugger_getInstance().debugTarget_1 = $this$swapView;
  var lastStack = {_v: navigator.stack_1.get_value_j01efc_k$()};
  // Inline function 'com.lightningkite.kiteui.views.direct.swapping' call
  var this_0 = $this$swapView;
  var queue = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var alreadySwapping = {_v: false};
  reactive(this_0, 8, ($this$reactive) => {
    var c = $this$reactive.invoke_r7m7el_k$(navigator.currentPage_1);
    queue.add_utx5q5_k$(c);
    var tmp;
    if (alreadySwapping._v) {
      return Unit_instance;
    }
    alreadySwapping._v = true;
    $l$loop: while (true) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!!queue.isEmpty_y1axqb_k$()) {
        break $l$loop;
      }
      var next = queue.removeAt_6niowx_k$(0);
      try {
        var newStack = navigator.stack_1.get_value_j01efc_k$();
        var transitionSet = get_theme($this$swapView).bodyTransitions_1;
        // Inline function 'kotlin.also' call
        var this_1 = (newStack.get_size_woubt6_k$() - lastStack._v.get_size_woubt6_k$() | 0) > 0 ? transitionSet.forward_1 : (newStack.get_size_woubt6_k$() - lastStack._v.get_size_woubt6_k$() | 0) < 0 && equals(firstOrNull(newStack), firstOrNull(lastStack._v)) ? transitionSet.reverse_1 : transitionSet.neutral_1;
        lastStack._v = newStack;
        var tmp_0 = this_1;
        this_0.swap_26x94b_k$(tmp_0, navigatorView$lambda$lambda(next, navigator, $this$swapView));
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e = $p;
          report(Exception().new_kotlin_Exception_9qyiel_k$('Failed to render ' + toString(next), e), 'SwapView.swapping');
        } else {
          throw $p;
        }
      }
    }
    alreadySwapping._v = false;
    return Unit_instance;
  });
  element.onStartup_vrxh3i_k$();
  _this__u8e3s4.addChild_2qpft2_k$(element);
  return element;
}
function navigatorView$lambda$lambda$slambda($$this$swapView, $screen) {
  return constructCallableReference(($this$launch, $completion) => orPromise($completion, function *($completion) {
    $$this$swapView.announceAsNewScreen_hgpm93_k$(yield* awaitOnce($screen.get_title_iz32un_k$(), $completion));
    return Unit_instance;
  }), 1);
}
function navigatorView$lambda$lambda($next, $navigator, $$this$swapView) {
  return ($this$swap) => {
    var screen = $next;
    // Inline function 'kotlin.with' call
    var $this$with = split($this$swap);
    set_pageNavigator($this$with.get_context_h02k06_k$(), $navigator);
    if (!(screen == null)) {
      // Inline function 'kotlin.with' call
      // Inline function 'com.lightningkite.kiteui.views.direct.padded' call
      var this_0 = get_asMain(themed($this$with, MainContentSemantic_getInstance()));
      var tmp$ret$5 = themed(this_0, ForcePaddingSemantic_getInstance());
      screen.render_w3x9d1_k$(tmp$ret$5);
    }
    if (!(screen == null)) {
      launch($this$with, VOID, VOID, navigatorView$lambda$lambda$slambda($$this$swapView, screen));
    }
    return Unit_instance;
  };
}
//region block: exports
export {
  navigatorView as navigatorView2ox898kg3o7zc,
};
//endregion

//# sourceMappingURL=NavigatorView.mjs.map
